var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gp-header"},[_c('div',{staticClass:"left",on:{"click":function($event){return _vm.goToWeb('https://www.gpowersoft.com/')}}},[_c('img',{attrs:{"src":require("@/assets/logo.png"),"height":"60"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }